
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("gwFTX", function(module, exports) {

$parcel$export(module.exports, "HomeActionsElement", () => $80aa12365357c0ae$export$4128169e0878a41d);
$parcel$export(module.exports, "HomeActionsAttachRef", () => $80aa12365357c0ae$export$762fcfeaa67873eb);

var $gwFzn = parcelRequire("gwFzn");

var $ee7An = parcelRequire("ee7An");
const $80aa12365357c0ae$export$4128169e0878a41d = /*#__PURE__*/ (0, $gwFzn.createContext)(null);
const $80aa12365357c0ae$export$762fcfeaa67873eb = /*#__PURE__*/ (0, $gwFzn.createContext)((0, $ee7An.default));

});

parcelRegister("dEIJ1", function(module, exports) {

$parcel$export(module.exports, "SkipLinksContext", () => $120f326e2f61fdb7$export$4c5cc3b14c7678a);
$parcel$export(module.exports, "useSkipLinkInternal", () => $120f326e2f61fdb7$export$707b94c26b8b75aa);
$parcel$export(module.exports, "useSkipLink", () => $120f326e2f61fdb7$export$89d9323301efc7d6);

var $gwFzn = parcelRequire("gwFzn");

var $ee7An = parcelRequire("ee7An");
const $120f326e2f61fdb7$export$4c5cc3b14c7678a = /*#__PURE__*/ (0, $gwFzn.createContext)({
    registerSkipLink: (0, $ee7An.default),
    unregisterSkipLink: (0, $ee7An.default)
});
const $120f326e2f61fdb7$var$useSkipLinks = ()=>(0, $gwFzn.useContext)($120f326e2f61fdb7$export$4c5cc3b14c7678a);
const $120f326e2f61fdb7$export$707b94c26b8b75aa = ({ id: id, label: label, listIndex: listIndex, onBeforeNavigate: onBeforeNavigate, isHidden: isHidden })=>{
    const { registerSkipLink: registerSkipLink, unregisterSkipLink: unregisterSkipLink } = $120f326e2f61fdb7$var$useSkipLinks();
    (0, $gwFzn.useEffect)(()=>{
        if (isHidden) /**
			 * Skip links are hidden for slots with 0 height or width.
			 * They should not be registered.
			 */ return;
        registerSkipLink({
            id: id,
            label: label,
            listIndex: listIndex,
            onBeforeNavigate: onBeforeNavigate,
            isHidden: isHidden
        });
        return ()=>{
            unregisterSkipLink(id);
        };
    }, [
        id,
        isHidden,
        label,
        listIndex,
        onBeforeNavigate,
        registerSkipLink,
        unregisterSkipLink
    ]);
};
const $120f326e2f61fdb7$export$89d9323301efc7d6 = (/**
	 * The unique ID for the skip link.
	 * You can use the `useSkipLinkId` hook to generate a unique ID.
	 */ id, /**
	 * The label for the skip link.
	 */ label, /**
	 * You can optionally set the position of the skip link in the list of skip links.
	 * Positions are zero-indexed.
	 */ listIndex)=>{
    $120f326e2f61fdb7$export$707b94c26b8b75aa({
        id: id,
        label: label,
        listIndex: listIndex
    });
};

});

parcelRegister("K0HEo", function(module, exports) {

$parcel$export(module.exports, "sideNavVar", () => $6a2ece5716de6726$export$951bf5156e86d974);
$parcel$export(module.exports, "panelVar", () => $6a2ece5716de6726$export$db0c2e1d744fb281);
$parcel$export(module.exports, "bannerMountedVar", () => $6a2ece5716de6726$export$515a0b1baafe906c);
$parcel$export(module.exports, "topBarMountedVar", () => $6a2ece5716de6726$export$a96e934b2a1eeee);
$parcel$export(module.exports, "sideNavLiveWidthVar", () => $6a2ece5716de6726$export$1216dacffd1e9e65);
$parcel$export(module.exports, "sideNavPanelSplitterId", () => $6a2ece5716de6726$export$5db28b16b6e686bc);
$parcel$export(module.exports, "panelPanelSplitterId", () => $6a2ece5716de6726$export$3452dcb65711af44);
$parcel$export(module.exports, "UNSAFE_topBarVar", () => $6a2ece5716de6726$export$f4afb213f937404c);
$parcel$export(module.exports, "UNSAFE_bannerVar", () => $6a2ece5716de6726$export$26354f9814213292);
$parcel$export(module.exports, "UNSAFE_sideNavLayoutVar", () => $6a2ece5716de6726$export$6bfc931a04ec5741);
$parcel$export(module.exports, "UNSAFE_panelLayoutVar", () => $6a2ece5716de6726$export$753bf7651b25db91);
$parcel$export(module.exports, "UNSAFE_MAIN_BLOCK_START_FOR_LEGACY_PAGES_ONLY", () => $6a2ece5716de6726$export$6460bd6a2446260);
/**
 * These variables are shared across the different page layout slots.
 * This violates the [UI styling standard](https://atlassian.design/components/eslint-plugin-ui-styling-standard/no-imported-style-values/usage).
 * We have chosen to ignore this rule to prevent duplicating them across the different slots, and to provide a high level view of them and how they relate.
 */ // These are "compressed" to discourage usage.
const $6a2ece5716de6726$export$951bf5156e86d974 = '--n_sNvw';
const $6a2ece5716de6726$export$594e6a30db7c057e = '--n_asDw';
const $6a2ece5716de6726$export$db0c2e1d744fb281 = '--n_pnlW';
const $6a2ece5716de6726$export$515a0b1baafe906c = '--n_bnrM';
const $6a2ece5716de6726$export$a96e934b2a1eeee = '--n_tbrM';
const $6a2ece5716de6726$export$1216dacffd1e9e65 = '--n_sNvlw';
const $6a2ece5716de6726$export$5db28b16b6e686bc = Symbol('SideNav PanelSplitter');
const $6a2ece5716de6726$export$de580d653bac8ad9 = Symbol('Aside PanelSplitter');
const $6a2ece5716de6726$export$3452dcb65711af44 = Symbol('Panel PanelSplitter');
const $6a2ece5716de6726$export$2874e68531ce3163 = `calc(100vh - var(--n_bnrM, 0px) - var(--n_tbrM, 0px))`;
const $6a2ece5716de6726$export$bfabd8c2c572ad29 = `calc(var(--n_bnrM, 0px) + var(--n_tbrM, 0px))`;
const $6a2ece5716de6726$export$f4afb213f937404c = '--topNavigationHeight';
const $6a2ece5716de6726$export$26354f9814213292 = '--bannerHeight';
const $6a2ece5716de6726$export$6bfc931a04ec5741 = '--leftSidebarWidth';
const $6a2ece5716de6726$export$bbbace2ff0c7ae1b = '--rightSidebarWidth';
const $6a2ece5716de6726$export$753bf7651b25db91 = '--rightPanelWidth';
const $6a2ece5716de6726$export$6460bd6a2446260 = `calc(var(${$6a2ece5716de6726$export$26354f9814213292}, 0px) + var(${$6a2ece5716de6726$export$f4afb213f937404c}, 0px))`;
const $6a2ece5716de6726$export$3055529fab2b4edf = `var(${$6a2ece5716de6726$export$6bfc931a04ec5741}, 0px)`;
const $6a2ece5716de6726$export$166d8fd766c3eb92 = `calc(var(${$6a2ece5716de6726$export$bbbace2ff0c7ae1b}, 0px) + var(${$6a2ece5716de6726$export$753bf7651b25db91}, 0px))`;
const $6a2ece5716de6726$export$61156ceb1a99f6a0 = {
    topBar: 4,
    banner: 4,
    sideNav: 2,
    panelSmallViewports: 1
};

});

parcelRegister("8jREP", function(module, exports) {

$parcel$export(module.exports, "DangerouslyHoistSlotSizes", () => $f3ec473aa51c642a$export$66e2c1a0115af861);

var $gwFzn = parcelRequire("gwFzn");
const $f3ec473aa51c642a$export$66e2c1a0115af861 = /*#__PURE__*/ (0, $gwFzn.createContext)(false);

});

parcelRegister("dGAIk", function(module, exports) {

$parcel$export(module.exports, "HoistCssVarToLocalGrid", () => $f173fcb581d867c3$export$cfa3cd08d675e56e);
$parcel$export(module.exports, "DangerouslyHoistCssVarToDocumentRoot", () => $f173fcb581d867c3$export$9f45a1325e3cdfb8);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $82dFP = parcelRequire("82dFP");
const $f173fcb581d867c3$export$cfa3cd08d675e56e = ({ variableName: variableName, value: value })=>/*#__PURE__*/ (0, $7UHDa.jsx)("style", {
        children: `#${(0, $82dFP.gridRootId)} { ${variableName}: ${value}px }`
    });
const $f173fcb581d867c3$var$getCssStringValue = (value)=>typeof value === 'number' ? `${value}px` : value;
const $f173fcb581d867c3$export$9f45a1325e3cdfb8 = ({ variableName: variableName, value: value, mediaQuery: mediaQuery, responsiveValue: responsiveValue })=>{
    /**
	 * Note don't put multiple variables in multiple lines. eg
	 * <style>
	 *   {css1}
	 *   {css2}
	 * </style>
	 *
	 * React will insert an empty HTML comment in between the text in SSR.
	 * This is not a valid tag and will break the page.
	 * <style>foo<!-- -->bar</style>
	 */ let style = `:root { ${variableName}: ${$f173fcb581d867c3$var$getCssStringValue(value)} }`;
    if (mediaQuery && responsiveValue) style += ` ${mediaQuery} { :root { ${variableName}: ${$f173fcb581d867c3$var$getCssStringValue(responsiveValue)} } }`;
    return(// Using a global style is required for SSR, as we can't use React hooks
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles
    /*#__PURE__*/ (0, $7UHDa.jsx)("style", {
        children: style
    }));
};

});
parcelRegister("82dFP", function(module, exports) {

$parcel$export(module.exports, "gridRootId", () => $7d16529c767c75c3$export$a6d827031bcb31d1);
$parcel$export(module.exports, "Root", () => $7d16529c767c75c3$export$be92b6f5f03c0fe9);
/* root.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $35pXk = parcelRequire("35pXk");

var $gwFzn = parcelRequire("gwFzn");

var $4jakm = parcelRequire("4jakm");

var $kRPaB = parcelRequire("kRPaB");

var $9zR6l = parcelRequire("9zR6l");

var $eXTHI = parcelRequire("eXTHI");

var $8jREP = parcelRequire("8jREP");

var $dh62b = parcelRequire("dh62b");

var $94Rup = parcelRequire("94Rup");

var $1Uf7b = parcelRequire("1Uf7b");
const $7d16529c767c75c3$export$a6d827031bcb31d1 = 'unsafe-design-system-page-layout-root';
const $7d16529c767c75c3$var$styles = {
    root: "_1e0c11p5 _1tke1kxc _1lmcq9em _yv0ei47z _2z0516ab _1ciragmp _12fkuz0r _12qzrxre _1rqt70if _xkmgbaui _jbc7rxre _tyve1jg8"
}; /**
    * The root component of the navigation system. It wraps the underlying components with the necessary contexts allowing to use certain data and hooks
    * @param skipLinksLabel - The very first element of the layout is a skip links container that can be accessed by pressing Tab button and holds the links to the other sections of the layout thus improving accessibility. This parameter defines the header text for this container
    */ 
function $7d16529c767c75c3$export$be92b6f5f03c0fe9({ children: children, xcss: xcss, UNSAFE_dangerouslyHoistSlotSizes: UNSAFE_dangerouslyHoistSlotSizes = false, skipLinksLabel: skipLinksLabel = 'Skip to:', testId: testId }) {
    const ref = (0, $gwFzn.useRef)(null);
    (0, $gwFzn.useEffect)(()=>{
        var child;
    }, []);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1Uf7b.SideNavVisibilityProvider), {
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $94Rup.SideNavToggleButtonProvider), {
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dh62b.SideNavElementProvider), {
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9zR6l.HomeActionsProvider), {
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jakm.OpenLayerObserver), {
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $8jREP.DangerouslyHoistSlotSizes).Provider, {
                            value: UNSAFE_dangerouslyHoistSlotSizes,
                            children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $eXTHI.SkipLinksProvider), {
                                children: [
                                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kRPaB.SkipLinksContainer), {
                                        label: skipLinksLabel,
                                        testId: testId
                                    }),
                                    /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
                                        ref: ref,
                                        className: (0, $35pXk.default)([
                                            $7d16529c767c75c3$var$styles.root,
                                            xcss
                                        ]),
                                        id: $7d16529c767c75c3$export$a6d827031bcb31d1,
                                        "data-testid": testId,
                                        children: children
                                    })
                                ]
                            })
                        })
                    })
                })
            })
        })
    });
}

});
parcelRegister("4jakm", function(module, exports) {

$parcel$export(module.exports, "OpenLayerObserver", () => $c174b6783566d938$export$97afddda23bcd287);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $5Uzw3 = parcelRequire("5Uzw3");

var $iHNqU = parcelRequire("iHNqU");
/**
 * Layers that are registered without a namespace are grouped under this fallback namespace.
 */ const $c174b6783566d938$var$noNamespaceSymbol = Symbol('no-namespace');
/**
 * Returns the number of open layers across all namespaces.
 * It calculates the sum of the set sizes in the map, which corresponds to the number of open layers.
 */ function $c174b6783566d938$var$getTotalOpenLayerCount(registry) {
    return Array.from(registry.values()).reduce((acc, listeners)=>acc + listeners.size, 0);
}
/**
 * Returns the layer count change listeners set for the namespace.
 * If there are no listeners registered for the namespace yet, it creates a new set
 * and adds it to the registry, then returns the new set.
 */ function $c174b6783566d938$var$getListeners({ registry: registry, namespace: namespace }) {
    // 1. If there are existing listeners for this namespace, return the existing set.
    const existingListeners = registry.get(namespace);
    if (existingListeners) return existingListeners;
    // 2. If there are no existing listeners for this namespace, create a new set for this namespace
    // and add it to the registry, then return the new set.
    const newSet = new Set();
    registry.set(namespace, newSet);
    return newSet;
}
/**
 * Returns an instance of the open layer observer API. It internally keeps track of the number of open layers and
 * exposes methods to get the current count, increment/decrement the count, and subscribe to changes.
 */ function $c174b6783566d938$var$createInternalAPI() {
    /**
	 * The layer count change listeners for each namespace.
	 */ const namespaceToChangeListenerRegistry = new Map();
    /**
	 * The `onClose` listeners for each namespace.
	 * Each layer provides an `onClose` callback. **When the layer is open**, its `onClose`
	 * callback is registered in this set.
	 *
	 * This data structure is also used determine the number of open layers.
	 */ const namespaceToLayerCloseListenerRegistry = new Map();
    /**
	 * Calls the appropriate layer count change listeners after the number of open layers has changed.
	 */ function callChangeListeners({ namespace: namespace, newCount: newCount }) {
        // 1. Call listeners registered to the specific namespace
        if (namespace) {
            const listenersForNamespace = namespaceToChangeListenerRegistry.get(namespace);
            // Using `Array.from` to ensure we iterate over a stable list - e.g. in case a listener adds to the registry while we are
            // iterating over it.
            Array.from(listenersForNamespace ?? []).forEach((listener)=>listener({
                    count: newCount
                }));
        }
        // 2. Call listeners registered without a specific namespace
        const noNamespaceListeners = namespaceToChangeListenerRegistry.get($c174b6783566d938$var$noNamespaceSymbol);
        // Return early if no listeners
        if (!noNamespaceListeners) return;
        // For the listeners without a specific namespace, we need to provide the sum of all namespace counts
        // as the callback `count` arg.
        const totalCount = $c174b6783566d938$var$getTotalOpenLayerCount(namespaceToLayerCloseListenerRegistry);
        Array.from(noNamespaceListeners).forEach((listener)=>listener({
                count: totalCount
            }));
    }
    /**
	 * Returns the current count of open layers.
	 *
	 * If a namespace is provided, the count for that namespace is returned.
	 * Otherwise, the sum of all namespace counts is returned.
	 */ function getCount({ namespace: namespace } = {}) {
        if (namespace) return namespaceToLayerCloseListenerRegistry.get(namespace)?.size ?? 0;
        // A specific namespace was not requested, so we return the sum across all namespaces.
        return $c174b6783566d938$var$getTotalOpenLayerCount(namespaceToLayerCloseListenerRegistry);
    }
    /**
	 * Adds a listener that will be called when the number of open layers changes.
	 *
	 * @returns a cleanup function to unsubscribe, which should be called when the component unmounts.
	 */ function onChange(listener, { namespace: providedNamespace } = {}) {
        /**
		 * We are wrapping the passed listener in a function to ensure that each call to `onChange` creates a unique
		 * function reference. This is to handle scenarios where the same function is provided to several different `onChange`
		 * calls - we want to ensure that each call to `unsubscribe` only removes the specific listener registration that was added.
		 */ function wrapped(...args) {
            listener(...args);
        }
        const namespace = providedNamespace ?? $c174b6783566d938$var$noNamespaceSymbol;
        const listenersForNamespace = $c174b6783566d938$var$getListeners({
            namespace: namespace,
            registry: namespaceToChangeListenerRegistry
        });
        listenersForNamespace.add(wrapped);
        return function unsubscribe() {
            listenersForNamespace.delete(wrapped);
            // If there are no listeners for this namespace, remove the registry entry.
            if (listenersForNamespace.size === 0) namespaceToChangeListenerRegistry.delete(namespace);
        };
    }
    /**
	 * Adds a listener to the registry that tells the observer how to close the layer component.
	 * The listener should only be added if the layer is open. This is handled by `useNotifyOpenLayerObserver`.
	 *
	 * All close listeners will be called by the observer when `closeLayers` is called.
	 *
	 * @returns a cleanup function to unsubscribe, which should be called when the component unmounts.
	 */ function onClose(listener, { namespace: providedNamespace }) {
        /**
		 * We are wrapping the passed listener in a function to ensure that each call to `onClose` creates a unique
		 * function reference. This is to handle scenarios where the same function is provided to several different `onClose`
		 * calls - we want to ensure that each call to `unsubscribe` only removes the specific listener registration that was added.
		 */ function wrapped() {
            listener();
        }
        const namespace = providedNamespace ?? $c174b6783566d938$var$noNamespaceSymbol;
        const listenersForNamespace = $c174b6783566d938$var$getListeners({
            namespace: namespace,
            registry: namespaceToLayerCloseListenerRegistry
        });
        listenersForNamespace.add(wrapped);
        callChangeListeners({
            namespace: providedNamespace,
            newCount: listenersForNamespace.size
        });
        return function unsubscribe() {
            listenersForNamespace.delete(wrapped);
            callChangeListeners({
                namespace: providedNamespace,
                newCount: listenersForNamespace.size
            });
            // If there are no listeners for this namespace, remove the registry entry.
            if (listenersForNamespace.size === 0) namespaceToLayerCloseListenerRegistry.delete(namespace);
        };
    }
    /**
	 * Closes all open layers registered across all namespaces.
	 */ function closeLayers() {
        // Using `Array.from` to ensure we iterate over a stable list - e.g. in case a listener adds to the registry while we are
        // iterating over it.
        Array.from(namespaceToLayerCloseListenerRegistry.values()).forEach((listeners)=>{
            Array.from(listeners).forEach((listener)=>listener());
        });
    }
    const internalAPI = {
        getCount: getCount,
        onChange: onChange,
        onClose: onClose,
        closeLayers: closeLayers
    };
    return internalAPI;
}
function $c174b6783566d938$export$97afddda23bcd287({ children: children }) {
    // Using state to ensure a stable reference to a single instance.
    const [internalAPI] = (0, $gwFzn.useState)(()=>$c174b6783566d938$var$createInternalAPI());
    const parentContext = (0, $gwFzn.useContext)((0, $iHNqU.OpenLayerObserverContext));
    // We don't expect a parent context. If there is one, that means this component is nested within another `OpenLayerObserver`
    // - which we don't support.
    (0, $5Uzw3.default)(parentContext === null, '`OpenLayerObserver` cannot be nested within another `OpenLayerObserver`.');
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $iHNqU.OpenLayerObserverContext).Provider, {
        value: internalAPI,
        children: children
    });
}

});

parcelRegister("kRPaB", function(module, exports) {

$parcel$export(module.exports, "SkipLinksContainer", () => $aa51ab1d068fecb1$export$fce25a0c32fbc1e1);
/* skip-links-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $dh538 = parcelRequire("dh538");

var $5dK2X = parcelRequire("5dK2X");

var $604Fw = parcelRequire("604Fw");

var $480dg = parcelRequire("480dg");
const $aa51ab1d068fecb1$var$styles = {
    root: "_2rkoglpi _1rjcu2gc _18zr12x7 _kqsw1n9t _1e02v47k _152tv47k _bfhk1bhr _16qs1cd0 _1pby1mrw _tzy4idpf _lcxvglyw _1digjh3g _1mygkb7n _18eu1wug",
    rootToAdd: "_zulp1b66 _1rjcutpp _18zrutpp _1e0c1txw _2lx21bp4",
    skipLinkList: "_1x8w11lx _2mzuglyw _1pfh1b66 _bozgze3t",
    skipLinkListToAdd: "_zulp1b66 _1e0c1txw _2lx21bp4 _1pfhze3t"
};
/**
 * Keydown handler to hide the skip links when escape is pressed.
 *
 * TODO: consider removing this, it doesn't make a lot of sense.
 * The skip links look like a popup but in reality they aren't.
 * Even though we hide them if you press TAB it will reopen the list and move to the next one...
 */ const $aa51ab1d068fecb1$var$closeOnEscape = (event)=>{
    if (event.key !== 'Escape') return;
    const activeElement = document.activeElement;
    if (activeElement instanceof HTMLElement) activeElement.blur();
};
const $aa51ab1d068fecb1$var$isOnlyWhitespaceRegex = /^\s*$/; /**
                                        * A container element for the skip links
                                        * The default label will be used when the `skipLinksLabel` attribute is not
                                        * provided or the attribute is an empty string. If a string comprised only of
                                        * spaces is provided, the skip link heading element will be removed, but the
                                        * default label will still be used in `title` attribute of the skip links
                                        * themselves.
                                        */ 
const $aa51ab1d068fecb1$export$fce25a0c32fbc1e1 = ({ label: label, testId: testId })=>{
    const sortedSkipLinks = (0, $604Fw.useSortedSkipLinks)();
    if (sortedSkipLinks.length === 0) return null;
    const isEmptyLabel = $aa51ab1d068fecb1$var$isOnlyWhitespaceRegex.test(label);
    return /*#__PURE__*/ (0, $7UHDa.jsxs)("div", {
        onKeyDown: $aa51ab1d068fecb1$var$closeOnEscape,
        "data-testid": testId ? `${testId}--skip-links-container` : undefined,
        className: (0, $35pXk.default)([
            $aa51ab1d068fecb1$var$styles.root,
            (0, $dh538.fg)('platform_design_system_nav4_skip_link_styling') && $aa51ab1d068fecb1$var$styles.rootToAdd
        ]),
        children: [
            !isEmptyLabel && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5dK2X.default), {
                weight: (0, $dh538.fg)('platform_design_system_nav4_skip_link_styling') ? 'bold' : 'medium',
                testId: testId ? `${testId}--skip-links-container--label` : undefined,
                children: label
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("ol", {
                className: (0, $35pXk.default)([
                    $aa51ab1d068fecb1$var$styles.skipLinkList,
                    (0, $dh538.fg)('platform_design_system_nav4_skip_link_styling') && $aa51ab1d068fecb1$var$styles.skipLinkListToAdd
                ]),
                children: sortedSkipLinks.map(({ id: id, label: label, onBeforeNavigate: onBeforeNavigate })=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $480dg.SkipLink), {
                        id: id,
                        onBeforeNavigate: onBeforeNavigate,
                        children: label
                    }, id))
            })
        ]
    });
};

});
parcelRegister("604Fw", function(module, exports) {

$parcel$export(module.exports, "SkipLinksDataContext", () => $29af16ccbbe01489$export$e9ab38ce6147d3d2);
$parcel$export(module.exports, "useSortedSkipLinks", () => $29af16ccbbe01489$export$b0b0d4fc1b356759);

var $gwFzn = parcelRequire("gwFzn");
const $29af16ccbbe01489$export$e9ab38ce6147d3d2 = /*#__PURE__*/ (0, $gwFzn.createContext)([]);
const $29af16ccbbe01489$var$assignIndex = (num, arr)=>{
    if (!arr.includes(num)) return num;
    return $29af16ccbbe01489$var$assignIndex(num + 1, arr);
};
const $29af16ccbbe01489$var$sortSkipLinks = (arr)=>{
    const customLinks = arr.filter((link)=>Number.isInteger(link.listIndex));
    if (customLinks.length === 0) return arr;
    const usedIndexes = customLinks.map((a)=>a.listIndex);
    const regularLinksWithIdx = arr.filter((link)=>link.listIndex === undefined).map((link, idx)=>{
        const listIndex = $29af16ccbbe01489$var$assignIndex(idx, usedIndexes);
        usedIndexes.push(listIndex);
        return {
            ...link,
            listIndex: listIndex
        };
    });
    return [
        ...customLinks,
        ...regularLinksWithIdx
    ].sort((a, b)=>a.listIndex - b.listIndex);
};
const $29af16ccbbe01489$export$b0b0d4fc1b356759 = ()=>{
    const skipLinksData = (0, $gwFzn.useContext)($29af16ccbbe01489$export$e9ab38ce6147d3d2);
    return (0, $gwFzn.useMemo)(()=>{
        return $29af16ccbbe01489$var$sortSkipLinks(skipLinksData);
    }, [
        skipLinksData
    ]);
};

});

parcelRegister("480dg", function(module, exports) {

$parcel$export(module.exports, "SkipLink", () => $c2dcbf5f910c3a70$export$ef95c37428582a65);
/* skip-link.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $35pXk = parcelRequire("35pXk");

var $gwFzn = parcelRequire("gwFzn");

var $d8F95 = parcelRequire("d8F95");

var $fpGTa = parcelRequire("fpGTa");
const $c2dcbf5f910c3a70$var$styles = {
    skipLinkListItem: "_1pfhze3t"
}; /**
    * Used for moving focus to the corresponding slot or custom target after clicking on a skip link.
    */ 
function $c2dcbf5f910c3a70$var$focusElement(element) {
    /**
   * Elements without an explicit `tabindex` attribute are not guaranteed to be focusable:
   * https://html.spec.whatwg.org/multipage/interaction.html#attr-tabindex
   *
   * Our slots are not interactive, so this is required.
   *
   * In the future we may want to check if there is an existing `tabindex` attribute,
   * as custom skip linked elements might already have one.
   */ element.setAttribute('tabindex', '-1'); /**
                                           * Cleanup the `tabindex` attribute we set when the slot or custom target loses focus.
                                           *
                                           * This is preferable to always having `tabindex="-1"` because always applying the tab index can:
                                           *
                                           * - mess with click events
                                           * - potentially cause a focus ring to be always visible
                                           */ 
    (0, $d8F95.bind)(element, {
        type: 'blur',
        listener () {
            element.removeAttribute('tabindex');
        },
        options: {
            // Using a one-time listener so it cleans itself up
            once: true
        }
    }); /**
       * Move focus to the slot or custom target.
       *
       * Calling `.focus()` will also scroll the element into view:
       * https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/focus
       */ 
    element.focus({
        // Forces the focus ring to appear after moving focus to the slot
        // https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/focus#focusvisible
        // @ts-expect-error - new and not in types yet
        focusVisible: true
    });
}
const $c2dcbf5f910c3a70$export$ef95c37428582a65 = ({ id: id, children: children, onBeforeNavigate: onBeforeNavigate })=>{
    const href = `#${id}`;
    const onClick = (0, $gwFzn.useCallback)((event)=>{
        event.preventDefault(); // Intentionally not using `document.querySelector` because many valid IDs are not valid selectors.
        const target = document.getElementById(id);
        if (!target) return;
         /**
       * Internal slots can attach an `onBeforeNavigate` callback.
       *
       * Side nav uses this to ensure it is expanded.
       */ 
        onBeforeNavigate?.();
        $c2dcbf5f910c3a70$var$focusElement(target); /**
                           * We should look into removing this, or only calling it in specific cases.
                           *
                           * It means if the skip link element is in the window scroll container
                           * then it might not get scrolled into view properly.
                           *
                           * This is not an issue for the default slots on desktop, but could break custom skip links or
                           * even `Aside` on mobile.
                           *
                           * Keeping existing behavior for now because resetting the window scroll is actually good for some cases.
                           * E.g. jumping to main / aside it makes sense to look at the start of the content.
                           */ 
        window.scrollTo(0, 0);
    }, [
        id,
        onBeforeNavigate
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)("li", {
        className: (0, $35pXk.default)([
            $c2dcbf5f910c3a70$var$styles.skipLinkListItem
        ]),
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fpGTa.default), {
            /**
            * It looks like Safari handles link clicks during `pointerdown` unless it has an explicit `tabIndex={0}` :/
            *
            * Adding this explicitly makes the behavior consistent between browsers and lets us `event.preventDefault()`
            * in the `onClick` handler.
            */ tabIndex: 0,
            href: href,
            onClick: onClick,
            children: children
        })
    });
};

});


parcelRegister("9zR6l", function(module, exports) {

$parcel$export(module.exports, "HomeActionsProvider", () => $0e0173b2767ec66c$export$8b9089606266983e);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $gwFTX = parcelRequire("gwFTX");
const $0e0173b2767ec66c$export$8b9089606266983e = ({ children: children })=>{
    const [element, setElement] = (0, $gwFzn.useState)(null);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gwFTX.HomeActionsElement).Provider, {
        value: element,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gwFTX.HomeActionsAttachRef).Provider, {
            value: setElement,
            children: children
        })
    });
};

});

parcelRegister("eXTHI", function(module, exports) {

$parcel$export(module.exports, "SkipLinksProvider", () => $26ba81d5dbd9fe8d$export$fe514f9f7b03d46f);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dEIJ1 = parcelRequire("dEIJ1");

var $604Fw = parcelRequire("604Fw");
const $26ba81d5dbd9fe8d$var$getByDomOrderSortFunction = ()=>{
    const layoutSlots = Array.from(document.querySelectorAll(`[data-layout-slot]`));
    return (a, b)=>{
        const indexA = a.listIndex ?? layoutSlots.indexOf(document.getElementById(a.id));
        const indexB = b.listIndex ?? layoutSlots.indexOf(document.getElementById(b.id));
        /**
		 * If they are tied it is because one (or both) is
		 * a custom skiplink with a set index.
		 *
		 * Give the custom skiplink priority.
		 */ if (indexA === indexB) {
            if (a.listIndex !== undefined) return -1;
            else return 1;
        }
        return indexA - indexB;
    };
};
const $26ba81d5dbd9fe8d$export$fe514f9f7b03d46f = ({ children: children })=>{
    const [links, setLinks] = (0, $gwFzn.useState)([]);
    const registerSkipLink = (0, $gwFzn.useCallback)((skipLinkData)=>{
        // Don't add duplicate skip links
        setLinks((oldLinks)=>{
            if (oldLinks.some(({ id: id })=>id === skipLinkData.id)) return oldLinks;
            return [
                ...oldLinks,
                skipLinkData
            ].sort($26ba81d5dbd9fe8d$var$getByDomOrderSortFunction());
        });
    }, []);
    const unregisterSkipLink = (0, $gwFzn.useCallback)((id)=>{
        setLinks((links)=>links.filter((link)=>link.id !== id));
    }, []);
    const contextValue = (0, $gwFzn.useMemo)(()=>{
        const data = {
            registerSkipLink: registerSkipLink,
            unregisterSkipLink: unregisterSkipLink
        };
        return data;
    }, [
        registerSkipLink,
        unregisterSkipLink
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dEIJ1.SkipLinksContext).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $604Fw.SkipLinksDataContext).Provider, {
            value: links,
            children: children
        })
    });
};

});

parcelRegister("dh62b", function(module, exports) {

$parcel$export(module.exports, "SideNavElementProvider", () => $ea7a9e744546d604$export$85c1ff84bbf6e6dc);
$parcel$export(module.exports, "useSideNavRef", () => $ea7a9e744546d604$export$fa4d0cff03b1ea4f);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");
const $ea7a9e744546d604$var$SideNavRefContext = /*#__PURE__*/ (0, $gwFzn.createContext)({
    current: null
});
function $ea7a9e744546d604$export$85c1ff84bbf6e6dc({ children: children }) {
    const sideNavRef = (0, $gwFzn.useRef)(null);
    return /*#__PURE__*/ (0, $7UHDa.jsx)($ea7a9e744546d604$var$SideNavRefContext.Provider, {
        value: sideNavRef,
        children: children
    });
}
function $ea7a9e744546d604$export$fa4d0cff03b1ea4f() {
    return (0, $gwFzn.useContext)($ea7a9e744546d604$var$SideNavRefContext);
}

});

parcelRegister("94Rup", function(module, exports) {

$parcel$export(module.exports, "SideNavToggleButtonProvider", () => $b1445687ddf9ea3f$export$ceb8e60e9790fc0f);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $5fMbj = parcelRequire("5fMbj");
const $b1445687ddf9ea3f$export$ceb8e60e9790fc0f = ({ children: children })=>{
    const [element, setElement] = (0, $gwFzn.useState)(null);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5fMbj.SideNavToggleButtonElement).Provider, {
        value: element,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5fMbj.SideNavToggleButtonAttachRef).Provider, {
            value: setElement,
            children: children
        })
    });
};

});
parcelRegister("5fMbj", function(module, exports) {

$parcel$export(module.exports, "SideNavToggleButtonElement", () => $30ef713eae219229$export$9c1768094bef896);
$parcel$export(module.exports, "SideNavToggleButtonAttachRef", () => $30ef713eae219229$export$fb8fa9a80240785e);

var $gwFzn = parcelRequire("gwFzn");

var $ee7An = parcelRequire("ee7An");
const $30ef713eae219229$export$9c1768094bef896 = /*#__PURE__*/ (0, $gwFzn.createContext)(null);
const $30ef713eae219229$export$fb8fa9a80240785e = /*#__PURE__*/ (0, $gwFzn.createContext)((0, $ee7An.default));

});


parcelRegister("1Uf7b", function(module, exports) {

$parcel$export(module.exports, "SideNavVisibilityProvider", () => $4119ec4ede116159$export$aac8e996360f6ad9);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $cvtof = parcelRequire("cvtof");
const $4119ec4ede116159$export$aac8e996360f6ad9 = ({ children: children })=>{
    // Defaults to null so we can determine if the value has been set yet (for SSR)
    const [sideNavState, setSideNavState] = (0, $gwFzn.useState)(null);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $cvtof.SideNavVisibilityState).Provider, {
        value: sideNavState,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $cvtof.SetSideNavVisibilityState).Provider, {
            value: setSideNavState,
            children: children
        })
    });
};

});



parcelRegister("bgZhH", function(module, exports) {

$parcel$export(module.exports, "useLayoutId", () => $945399976d81ad92$export$110c3550c7c1c9aa);

var $c0qxy = parcelRequire("c0qxy");
function $945399976d81ad92$export$fa3cfac0c8e29c5c() {
    const uniqueId = (0, $c0qxy.useId)();
    return uniqueId;
}
function $945399976d81ad92$export$110c3550c7c1c9aa({ providedId: providedId } = {}) {
    const uniqueId = $945399976d81ad92$export$fa3cfac0c8e29c5c();
    const id = providedId ? providedId : uniqueId;
    return id;
}

});


//# sourceMappingURL=top-nav.4e7cc26e.js.map
